import { motion } from "framer-motion";
import { useState } from "react";
import PageHero from "../components/PageHero";
import { clients } from "../data/site";

const categorised = [
  { name: "RMZ CORP", cat: "Commercial" },
  { name: "LODHA", cat: "Residential", logo: "/logos/lodha.png" },
  { name: "GODREJ", cat: "Residential", logo: "/logos/godrej.png" },
  { name: "HIRANANDANI", cat: "Residential", logo: "/logos/hiranandani.png" },
  { name: "KIMS HOSPITALS", cat: "Healthcare", logo: "/logos/kims.png" },
  { name: "GREENKO", cat: "Industrial", logo: "/logos/greenko.png" },
  { name: "BIOLOGICAL E", cat: "Industrial", logo: "/logos/biological-e.png" },
  { name: "HITEX", cat: "Commercial", logo: "/logos/hitex.png" },
  { name: "MINERVA", cat: "Hospitality", logo: "/logos/minerva.png" },
  { name: "DOYEN", cat: "Commercial", logo: "/logos/doyen.png" },
  { name: "E11 HOMES", cat: "Residential", logo: "/logos/e11-homes.png" },
  { name: "ISTA HOMES", cat: "Residential", logo: "/logos/ista-homes.png" },
  { name: "VISTA SPACES", cat: "Commercial", logo: "/logos/vista-spaces.png" },
  { name: "SRAVANTHI", cat: "Residential", logo: "/logos/sravanthi.png" },
  { name: "PRATHIMA", cat: "Healthcare", logo: "/logos/prathima.png" },
  { name: "G PULLA REDDY", cat: "Hospitality", logo: "/logos/g-pulla-reddy.png" },
  { name: "KLR PROPERTIES", cat: "Residential", logo: "/logos/klr-properties.png" },
  { name: "L&W", cat: "Commercial", logo: "/logos/lw.png" },
  { name: "SIRI SAMPADA", cat: "Residential" },
  { name: "SRI GAYATHRI", cat: "Residential", logo: "/logos/sri-gayathri.png" },
  { name: "ARD ESTATES & PROJECTS", cat: "Residential", logo: "/logos/ard-estates.png" },
];

const cats = ["All", "Residential", "Commercial", "Healthcare", "Industrial", "Hospitality"];

export default function ClientsPage() {
  const [filter, setFilter] = useState("All");
  const filtered = filter === "All" ? categorised : categorised.filter((c) => c.cat === filter);

  return (
    <main data-testid="clients-page">
      <PageHero
        eyebrow="Our Clients"
        title="The names building modern Hyderabad."
        description={`Over ${clients.length}+ developers, hospitals, industrial groups and architects have trusted Hoflich with their critical approvals pipeline. A relationship-led practice that grows with the city.`}
        image="https://images.unsplash.com/photo-1763560956421-b3e4083e9fc9?crop=entropy&cs=srgb&fm=jpg&w=2200&q=85"
        breadcrumbs={["Home", "Clients"]}
      />

      <section className="relative pb-32 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap gap-2 md:gap-3 mb-10">
            {cats.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`client-filter-${c.toLowerCase()}`}
                className={`px-5 py-2.5 rounded-full text-xs tracking-[0.15em] uppercase border transition-colors ${
                  filter === c
                    ? "bg-[#C96A2B] border-[#C96A2B] text-black"
                    : "border-white/10 text-white/65 hover:border-[#C96A2B] hover:text-[#C96A2B]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <motion.div layout className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {filtered.map((c, i) => (
              <motion.div
                layout
                key={c.name}
                data-testid={`client-card-${i}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
                className="group relative bg-white border border-zinc-100 rounded-2xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 h-24 md:h-28 grid place-items-center px-6 text-center"
              >
                <div className="flex flex-col items-center justify-center w-full">
                  {c.logo ? (
                    <img 
                      src={c.logo} 
                      alt={c.name} 
                      className="h-14 md:h-18 w-auto max-w-[85%] object-contain opacity-75 group-hover:opacity-100 group-hover:scale-105 transition-all duration-300 filter brightness-0" 
                    />
                  ) : (
                    <p className="font-display text-base md:text-lg tracking-[0.16em] text-zinc-800 group-hover:text-[#C96A2B] transition-colors">
                      {c.name}
                    </p>
                  )}
                  <p className="text-[10px] tracking-[0.25em] uppercase text-zinc-400 mt-2 font-medium">
                    {c.cat}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <p className="mt-10 text-center text-sm text-white/45 italic">
            * Client wordmarks shown for reference. All brands are property of their respective owners.
          </p>
        </div>
      </section>
    </main>
  );
}
